<template>
  <div class="Presidentunit">
    <ComTitlte titleEn="PRESIDENT UNIT" titleZh="会长、副会长单位"></ComTitlte>
    <div class="unitBox">
      <div class="unitItem unitItem1">
        <div class="u_title">会长单位</div>
        <div class="u_logo">
          <img src="@/assets/img/company/logo_gzgk.png" alt="广州工控" />
        </div>
      </div>
      <div class="unitItem unitItem2">
        <div class="u_title">常务副会长单位</div>
        <div class="u_logo">
          <img src="@/assets/img/company/logo_ghjy.png" alt="广化交易" />
        </div>
      </div>
      <div class="unitItem unitItem3">
        <div class="u_title">副会长单位</div>
        <div class="u_logo">
          <img src="@/assets/img/company/logo_nfjy.png" alt="南方碱业" />
          <img src="@/assets/img/company/logo_jfkj.png" alt="金发科技" />
          <img src="@/assets/img/company/logo_jthg.png" alt="集泰化工" />
          <img src="@/assets/img/company/logo_jbsthj.png" alt="巨邦生态环境" />
        </div>
      </div>
      <!-- <div
        v-for="item in unitList"
        :class="[
          item.columnType == '56'
            ? 'unitItem1'
            : item.columnType == '57'
            ? 'unitItem2'
            : 'unitItem3',
          'unitItem',
        ]"
        :key="item.id"
      >
        <div class="u_title">{{ item.lable }}</div>
        <div class="u_logo">
          <img
            v-for="aitem in item.arr"
            :key="aitem.id"
            :src="imgBaseUrl + aitem.imageUrl"
            :alt="aitem.imageDesc"
          />
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import ComTitlte from "@/components/common/comTitle";
export default {
  name: "Presidentunit",
  data() {
    return {
      // 会长
      unitList: [],
      imgBaseUrl: "",
    };
  },
  created() {
    this.getImageManageList();
  },
  methods: {
    async getImageManageList() {
      let res = await this.$request.getImageManageList({ columnType: "56" });
      if (res.code == 200) {
        this.unitList = this.fiterManage(res.rows);
        this.imgBaseUrl = this.$store.state.baseUrl;
      }
    },
    fiterManage(arr) {
      let manageObj = {
        56: { lable: "会长", arr: [] },
        57: { lable: "常务副会长", arr: [] },
        58: { lable: "副会长", arr: [] },
      };
      arr.map((item) => {
        if (item.columnType == "56") {
          manageObj[item.columnType]["id"] = item.imageId;
          manageObj[item.columnType]["arr"].push(item);
        } else if (item.columnType == "57") {
          manageObj[item.columnType]["id"] = item.imageId;
          manageObj[item.columnType]["arr"].push(item);
        } else {
          manageObj[item.columnType]["id"] = item.imageId;
          manageObj[item.columnType]["arr"].push(item);
        }
      });
      return manageObj;
    },
  },
  components: { ComTitlte },
};
</script>

<style lang="scss" scoped>
.Presidentunit {
  position: relative;
  .unitBox {
    display: flex;
    justify-content: space-between;
    margin: 30px 0 0 0;
    .unitItem {
      width: 210px;
      &.unitItem3 {
        width: 700px;
      }
      .u_title {
        height: 40px;
        line-height: 40px;
        text-align: center;
        background-color: #f5f9ff;
        border: solid 1px #e5e5e5;
      }
      .u_logo {
        border: solid 1px #e5e5e5;
        border-top: none;
        display: flex;
        justify-content: space-around;
        padding: 20px 0;
        img {
          width: 127px;
          height: 50px;
        }
      }
    }
  }
}
</style>
